import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const TechChat: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component="svg"
    xmlns="http://www.w3.org/2000/svg"
    width={460}
    height={315}
    viewBox="0 0 460 315"
    fill="none"
    {...props}
  >
    <path
      fill="#00BED5"
      d="M37.942 97.761c49.347-49.346 129.357-49.346 178.704 0 49.347 49.347 49.347 129.358 0 178.705-43.339 43.338-110.31 48.606-159.41 15.825L0 314.407l22.116-57.236c-32.78-49.1-27.513-116.071 15.826-159.41Z"
    />
    <path
      fill="#00BED5"
      d="M37.942 97.761c49.347-49.346 129.357-49.346 178.704 0 49.347 49.347 49.347 129.358 0 178.705-43.339 43.338-110.31 48.606-159.41 15.825L0 314.407l22.116-57.236c-32.78-49.1-27.513-116.071 15.826-159.41Z"
    />
    <path
      fill="#00BED5"
      d="M37.942 97.761c49.347-49.346 129.357-49.346 178.704 0 49.347 49.347 49.347 129.358 0 178.705-43.339 43.338-110.31 48.606-159.41 15.825L0 314.407l22.116-57.236c-32.78-49.1-27.513-116.071 15.826-159.41Z"
    />
    <path
      fill="#80DFEA"
      d="M414.315 54.07c-49.041-49.04-128.546-49.04-177.587 0-49.041 49.041-49.041 128.546 0 177.587 43.068 43.069 109.628 48.312 158.422 15.732l56.884 21.975-21.975-56.883c32.568-48.771 27.324-115.343-15.744-158.41Z"
    />
    <path
      fill="#00BED5"
      d="M37.942 97.761c49.347-49.346 129.357-49.346 178.704 0 49.347 49.347 49.347 129.358 0 178.705-43.339 43.338-110.31 48.606-159.41 15.825L0 314.407l22.116-57.236c-32.78-49.1-27.513-116.071 15.826-159.41Z"
    />
    <path
      fill="#fff"
      d="M182.549 136.867H72.039a10.086 10.086 0 0 0-10.088 10.088 10.086 10.086 0 0 0 10.088 10.088h110.51a10.086 10.086 0 0 0 10.088-10.088 10.086 10.086 0 0 0-10.088-10.088ZM182.549 177.231H72.039a10.086 10.086 0 0 0-10.088 10.088 10.086 10.086 0 0 0 10.088 10.088h110.51a10.086 10.086 0 0 0 10.088-10.088 10.086 10.086 0 0 0-10.088-10.088ZM182.549 217.583H72.039a10.086 10.086 0 0 0-10.088 10.089A10.086 10.086 0 0 0 72.04 237.76h110.51a10.086 10.086 0 0 0 10.088-10.088c0-5.574-4.515-10.089-10.088-10.089Z"
    />
    <path
      fill="#009CBD"
      d="M210.626 92.13c-20.317 46.043-11.628 101.809 26.102 139.528 2.081 2.081 4.233 4.044 6.419 5.961 20.141-46.231 11.3-102.045-26.513-139.857a135.203 135.203 0 0 0-6.008-5.632Z"
    />
    <path
      fill="#FF612B"
      d="M421.64 37.01c-49.347-49.347-129.357-49.347-178.704 0-49.347 49.347-49.347 129.357 0 178.704 43.338 43.339 110.31 48.606 159.41 15.826l57.236 22.116-22.116-57.236c32.78-49.088 27.512-116.071-15.826-159.41Z"
    />
    <path
      fill="#fff"
      d="M387.543 96.303h-110.51a10.086 10.086 0 0 1-10.088-10.088 10.086 10.086 0 0 1 10.088-10.088h110.51a10.086 10.086 0 0 1 10.088 10.088c0 5.561-4.515 10.088-10.088 10.088ZM387.543 136.656h-110.51a10.086 10.086 0 0 1-10.088-10.088c0-5.574 4.515-10.089 10.088-10.089h110.51c5.573 0 10.088 4.515 10.088 10.089a10.086 10.086 0 0 1-10.088 10.088ZM387.543 177.02h-110.51a10.086 10.086 0 0 1-10.088-10.088 10.086 10.086 0 0 1 10.088-10.088h110.51a10.086 10.086 0 0 1 10.088 10.088 10.086 10.086 0 0 1-10.088 10.088Z"
    />
  </Box>
)
export default TechChat
